import React, { useState } from 'react';
import { C } from '../theme';
import { Card, CardTitle, RCard, QuoteBox, FinInput, BtnPrimary } from '../components/Card';
import { HOUSE_DATA, reduceNum } from '../utils/data';
import useUserStore from '../store/userStore';

export default function HouseScreen() {
  const [num, setNum] = useState('');
  const [result, setResult] = useState(null);
  const { user } = useUserStore();

  function analyze() {
    const n = parseInt(num);
    if (!n || n < 1) return;
    const root = reduceNum(String(n).split('').reduce((a,b)=>a+parseInt(b),0));
    const hd = HOUSE_DATA[root] || HOUSE_DATA[1];
    const userRoot = user?.root_number;
    const isSuitable = userRoot && hd.suit.includes(userRoot);
    setResult({ n, root, hd, userRoot, isSuitable });
  }

  return (
    <div>
      <QuoteBox text="حين يتعارض رقمك الجوهري مع تردد البيئة من حولك، يُعاد تشكيل عالمك الخارجي بما يُربكك داخلياً" src="جذر الفلك، الجزء الثالث" />
      <Card>
        <CardTitle>🏠 رقم منزلك وتوافقه مع رقمك</CardTitle>
        <p style={{fontSize:12,color:C.text2,marginBottom:14,lineHeight:1.7}}>أدخل رقم منزلك أو شقتك (الرقم فقط)، وسنحسب جذره ونقارنه مع جذرك الشخصي.</p>
        <FinInput value={num} onChange={e=>setNum(e.target.value)} placeholder="مثال: 25 أو 147..." type="number" min="1" style={{marginBottom:8}}/>
        <BtnPrimary onClick={analyze} style={{marginTop:0}}>✦ حلّل رقم المنزل</BtnPrimary>

        {result && (
          <RCard type={result.isSuitable?'pos':'warn'} style={{marginTop:14}}>
            <div style={{fontSize:12,color:C.gold,fontWeight:600,marginBottom:8}}>
              رقم منزلك: {result.n} → جذره: <strong style={{fontSize:22,fontFamily:'Amiri,serif'}}>{result.root}</strong>
              {result.isSuitable?' ✦ يناسب رقمك!':result.userRoot?' ⚠ قد لا يناسب رقمك تماماً':''}
            </div>
            <div style={{fontSize:14,lineHeight:1.75,marginBottom:8}}><strong>{result.hd.title}</strong><br/>{result.hd.desc}</div>
            <ul style={{listStyle:'none',padding:0,margin:0}}>
              <li style={{fontSize:12,color:C.text2,paddingRight:14,position:'relative',marginBottom:5,lineHeight:1.6}}><span style={{position:'absolute',right:0,color:C.goldDim,fontSize:8,top:4}}>◆</span>يناسب أصحاب الأرقام: {result.hd.suit.join('، ')}</li>
              <li style={{fontSize:12,color:C.text2,paddingRight:14,position:'relative',marginBottom:5,lineHeight:1.6}}><span style={{position:'absolute',right:0,color:C.goldDim,fontSize:8,top:4}}>◆</span>تحذير: {result.hd.warn}</li>
              {result.userRoot&&!result.isSuitable&&<li style={{fontSize:12,color:C.gold,paddingRight:14,position:'relative',lineHeight:1.6}}><span style={{position:'absolute',right:0,color:C.goldDim,fontSize:8,top:4}}>◆</span>من الكتاب: إذا لم يناسبك رقم منزلك، أضف حجراً أو نباتاً يحمل طاقة رقمك ({result.userRoot}) عند المدخل</li>}
              {result.userRoot&&result.isSuitable&&<li style={{fontSize:12,color:C.green,paddingRight:14,position:'relative',lineHeight:1.6}}><span style={{position:'absolute',right:0,color:C.goldDim,fontSize:8,top:4}}>◆</span>رقم منزلك ({result.root}) يتوافق مع جذرك ({result.userRoot}) — هذه البيئة تدعم طاقتك الطبيعية</li>}
            </ul>
          </RCard>
        )}
      </Card>
    </div>
  );
}
